import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue";
import { computed } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ProfileDdList',
    props: {
        texts: {}
    },
    setup(__props) {
        const props = __props;
        const texts = computed(() => {
            if (props.texts.length == 1 && props.texts[0] == '') {
                return [];
            }
            return props.texts;
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("dd", {
                class: _normalizeClass(texts.value.length == 0 ? 'empty' : '')
            }, [
                _createElementVNode("ul", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(texts.value, (text) => {
                        return (_openBlock(), _createElementBlock("li", { key: text }, _toDisplayString(text), 1));
                    }), 128))
                ])
            ], 2));
        };
    }
});
